/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorweeklabel3Inputs */

const en_menueditorweeklabel3 = /** @type {(inputs: Menueditorweeklabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applies to`)
};

const de_menueditorweeklabel3 = /** @type {(inputs: Menueditorweeklabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gilt für`)
};

/**
* | output |
* | --- |
* | "Applies to" |
*
* @param {Menueditorweeklabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorweeklabel3 = /** @type {((inputs?: Menueditorweeklabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorweeklabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorweeklabel3(inputs)
	return de_menueditorweeklabel3(inputs)
});
export { menueditorweeklabel3 as "menuEditorWeekLabel" }